var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "head_box flex_start flex_center_align" },
        [
          _c("svg-icon", { attrs: { "icon-class": "edit_2_line" } }),
          _c(
            "span",
            { staticClass: "hd_title" },
            [
              _vm._t("hd_title", function () {
                return [_vm._v("報告書一覧")]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "h_date flex_center_align" },
        [
          _c("svg-icon", {
            staticClass: "h_svg",
            attrs: { "icon-class": "tryangle_down" },
          }),
          _c(
            "span",
            { staticClass: "h_title h_img_none" },
            [
              _vm._t("h_title", function () {
                return [_vm._v("書類の提出を行ってください")]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._l(_vm.fileList, function (row, index) {
        return _c("div", { key: index, staticClass: "file_box_new" }, [
          _c(
            "div",
            { staticClass: "header_box flex_start flex_center_align" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$baseLodash.replace(
                        row.docName,
                        "原価見積書",
                        "見積書"
                      )
                    ) +
                    " "
                ),
                _vm.checkEnumFlag(row.requiredFlg)
                  ? _c("i", { staticClass: "red" }, [_vm._v("*")])
                  : _vm._e(),
              ]),
              row.uploadCheck
                ? _c("vab-upload", {
                    attrs: { "upload-url": row.uploadUrl, "params-data": row },
                    on: { "on-success": _vm.successFile },
                  })
                : _vm._e(),
              row.docName == "少量廃棄物運搬指示書"
                ? _c("span", { staticClass: "hint_txt_red" }, [
                    _vm._v(" ※ 原本をご郵送にてご提出ください "),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "file_item_box",
              class: { flex_space: row.list && row.list.length > 1 },
            },
            _vm._l(row.list, function (item, cIndex) {
              return _c(
                "div",
                {
                  key: cIndex,
                  staticClass: "file_item",
                  class: { more_colum: row.list.length > 1 },
                },
                [
                  _c(
                    "div",
                    { staticClass: "file_item_ne flex_colum" },
                    [
                      _c(
                        "div",
                        { staticClass: "company flex_start flex_center_align" },
                        [
                          _c("svg-icon", {
                            staticClass: "user",
                            attrs: { "icon-class": "user_4_fill" },
                          }),
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(item.company)),
                          ]),
                          item.showStateList && item.showStateList.length > 0
                            ? _vm._l(
                                item.showStateList,
                                function (state, sIndex) {
                                  return _c(
                                    "div",
                                    {
                                      key: sIndex,
                                      staticClass:
                                        "state_box flex_start flex_center_align",
                                      style: {
                                        backgroundColor: state.bg,
                                        color: state.color,
                                        borderColor: state.borderColor,
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "check_icon",
                                        attrs: { "icon-class": state.icon },
                                      }),
                                      _c("div", { staticClass: "mark" }, [
                                        _vm._v(
                                          _vm._s(state.docSubmitStatusName)
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._l(item.fileList, function (file, f) {
                        return _c(
                          "div",
                          {
                            key: f,
                            staticClass: "file_inner_item flex_start pl0",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "arrow_box" },
                              [
                                _c("svg-icon", {
                                  staticClass: "arrow",
                                  attrs: { "icon-class": "tryangle_right" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "flex_colum file_name_box" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "file_name",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downLoad(row, file)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(file.fileName) + " ")]
                                ),
                                _c("div", { staticClass: "file_time" }, [
                                  _vm._v(
                                    " アップロード日時：" +
                                      _vm._s(file.createDate) +
                                      " " +
                                      _vm._s(
                                        _vm.formatTimeMsel(file.createTime)
                                      ) +
                                      " "
                                  ),
                                ]),
                                _vm.deleteShow(file)
                                  ? _c("svg-icon", {
                                      staticClass: "del",
                                      attrs: {
                                        "icon-class": "close_circle_fill",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteFile(
                                            row,
                                            file,
                                            item,
                                            f
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  item.dlnBtnList && item.dlnBtnList.length > 0
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn_box_file flex_start flex_center_align",
                          },
                          _vm._l(item.dlnBtnList, function (btn, d) {
                            return _c(
                              "div",
                              {
                                key: d,
                                staticClass:
                                  "state_box flex_start flex_center_align",
                                class: [btn.check ? btn.checkClassName : ""],
                                on: {
                                  click: function ($event) {
                                    return _vm.handleBtn(btn)
                                  },
                                },
                              },
                              [
                                btn.type == "button"
                                  ? [
                                      _c("svg-icon", {
                                        staticClass: "check_icon",
                                        attrs: { "icon-class": btn.icon },
                                      }),
                                      _c("div", { staticClass: "mark" }, [
                                        _vm._v(_vm._s(btn.name)),
                                      ]),
                                    ]
                                  : btn.type == "checkbox"
                                  ? [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: btn.check,
                                            callback: function ($$v) {
                                              _vm.$set(btn, "check", $$v)
                                            },
                                            expression: "btn.check",
                                          },
                                        },
                                        [_vm._v(_vm._s(btn.name))]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            0
          ),
        ])
      }),
      _c(
        "div",
        { staticClass: "bs_btn_main m12 new_btn_icon" },
        [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }